import React, { createContext, useState, useEffect } from 'react';

export const TimeContext = createContext();

export const TimeProvider = ({ children }) => {
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleString('en-US', { timeZone: 'Africa/Nairobi' })
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleString('en-US', { timeZone: 'Africa/Nairobi' }));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <TimeContext.Provider value={currentTime}>
      {children}
    </TimeContext.Provider>
  );
};